import { getStringOrUndefined } from './string.ts';

/**
 * Returns the input as a finite number, otherwise `undefined`. Only `""` counts as empty,
 * so a whitespace-only string gives `0`.
 */
export function stringToNumberOrUndefined(input: string) {
  const number = Number(getStringOrUndefined(input));
  if (Number.isFinite(number)) {
    return number;
  }
  return undefined;
}
